import type { CuriosityParams } from '../../Curiosity';
import { TIMING_NAME } from './timingsTypes';
import { isNil } from '../../Utilities';

type TimingPerformance = {
  start?: number;
  elapsed?: number;
};

export type TimingPerformances = {
  [key in TIMING_NAME]: TimingPerformance;
};

type Timings =
  | {
      [key in TIMING_NAME]: number;
    }
  | Record<string, unknown>;

export const startServerSideTiming = (): TimingPerformances => {
  const tp = {} as TimingPerformances;
  startTiming(TIMING_NAME.SERVER_SIDE, tp);
  return tp;
};

export const endServerSideTiming = (curiosityParams: CuriosityParams, tp: TimingPerformances) => {
  if (!tp) return;
  endTiming(TIMING_NAME.SERVER_SIDE, tp);
  // eslint-disable-next-line no-param-reassign
  curiosityParams.timingPerformances = getNormalisedTimingPerformances(tp);
};

export const startTiming = (timingName: TIMING_NAME, tp?: TimingPerformances): void => {
  if (!tp) return;
  // eslint-disable-next-line no-param-reassign
  tp[timingName] = { start: new Date().getTime() };
};

export const endTiming = (timingName: TIMING_NAME, tp?: TimingPerformances): void => {
  if (!tp) return;
  if (!isNil(tp?.[timingName]?.start)) {
    const end = new Date().getTime();
    const start = tp[timingName].start as number;
    // eslint-disable-next-line no-param-reassign
    tp[timingName].elapsed = end - start;
  }
};

export const getNormalisedTimingPerformances = (tp: TimingPerformances): TimingPerformances =>
  <TimingPerformances>Object.entries(tp).reduce(
    (result, [key, value]) => ({
      ...result,
      [key]: !isNil(value.elapsed) ? { elapsed: value.elapsed } : { start: value.start },
    }),
    {}
  );

export const getElapsedTimings = (tp: TimingPerformances): Timings =>
  <TimingPerformances>Object.entries(tp).reduce((result, [key, value]) => ({ ...result, [key]: value.elapsed }), {});

// export const getElapsedTiming = (tp: TimingPerformances, timingName: TIMING_NAME): number => tp[timingName]?.elapsed;
